<template>
  <div>
    @todo : make top navbar anonymous, @see https://bureaux-a-partager.atlassian.net/browse/MATCH-9945
  </div>
</template>
